import { DataObjectView } from '@atlas-frontend/sdk';
import { DataObjectEdit } from '../data-objects/DataObjectEdit';
import { useDataObjectActionHandlers } from '../data-objects/useDataObjectActionHandlers';
import { INPUT_DATA_OBJECT_ROUTES } from './InputDataObjects';

export const InputDataObjectEdit = () => {
  const { handleCancel } = useDataObjectActionHandlers('inputDataObjectView');

  return (
    <DataObjectEdit
      routes={INPUT_DATA_OBJECT_ROUTES}
      view={DataObjectView.IN}
      onCancel={handleCancel}
    />
  );
};
